import script from "./screenData.vue?vue&type=script&setup=true&lang=js"
export * from "./screenData.vue?vue&type=script&setup=true&lang=js"

import "./screenData.vue?vue&type=style&index=0&id=0425c51e&lang=scss"

const __exports__ = script;

export default __exports__